// extracted by mini-css-extract-plugin
export default {"container":"OriginSubMenu_container__-N79+","menuContainer":"OriginSubMenu_menuContainer__Fz5rw"};